import React from 'react';
import './ProjectCard.css';

const ProjectCard = ({ 
  title = "Featured Project",
  paragraphs = [],
  stats = [],
  className = ""
}) => {
  return (
    <div className={`project-card ${className}`}>
      <h3 className="project-title">{title}</h3>
      <div className="project-content">
        <div className="project-description">
          {paragraphs.map((paragraph, index) => (
            React.isValidElement(paragraph) ? 
              <div key={index}>{paragraph}</div> : 
              <p key={index}>{paragraph}</p>
          ))}
        </div>
        {stats.length > 0 && (
          <div className="project-stats">
            {stats.map((stat, index) => (
              <div className="stat-item" key={index}>
                <span className="stat-value">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard; 